import React, { useState, useEffect } from 'react';
import './CurrentDate.css'

interface CurrentDateProps {}

// Interface for representing date information
interface DateInfo {
  day: number;
  month: number;
  year: number;
  dayOfWeek: string;
}

const CurrentDate: React.FC<CurrentDateProps> = () => {
  const [currentDate, setCurrentDate] = useState<DateInfo | null>(null);

  useEffect(() => {
    const now = new Date();
    setCurrentDate({
      day: now.getDate(),
      month: now.getMonth() + 1, // Months are zero-indexed
      year: now.getFullYear(),
      dayOfWeek: now.toLocaleDateString('en-US', { weekday: 'long' }),
    });
  }, []);

  if (!currentDate) return null;

  return (
    <div className="current-date">
      <span>{currentDate.dayOfWeek}</span>, {currentDate.day} {getMonthName(currentDate.month)} {currentDate.year}
    </div>
  );
};

// Helper function to get month name
function getMonthName(month: number): string {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return months[month - 1];
}

export default CurrentDate;
